import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import CTABand from "../components/resource/CTABand";
import { RESOURCES } from "../i18n/resources";
import { container, item, inView } from "../components/service/presets";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const { t, dir, lang } = useLang();
  const flip = dir === "rtl" ? "scaleX(-1)" : "none";
  const blogs = RESOURCES[lang].blogs;

  return (
    <div>
      <PageHero tag={t.res.blogsTag} title={t.res.blogsTitle} />
      <section className="py-12 rq-light">
        <motion.div {...inView} variants={container} className="rq-container grid gap-7 md:grid-cols-3">
          {blogs.map((b) => (
            <motion.div key={b.slug} variants={item} whileHover={{ y: -8 }}>
              <Link to={`/blog/${b.slug}`} className="rq-card overflow-hidden h-full group block" data-testid={`blog-card-${b.slug}`}>
                <div className="h-52 overflow-hidden">
                  <img src={b.image} alt={b.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                </div>
                <div className="p-6">
                  <span className="text-xs font-semibold text-[color:var(--rq-green)]">{b.category} • {b.date}</span>
                  <h3 className="font-display mt-3 text-lg font-semibold text-white leading-snug">{b.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[color:var(--rq-muted)] line-clamp-3">{b.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[color:var(--rq-green)]">
                    {t.res.readMore}
                    <ArrowRight size={15} style={{ transform: flip }} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </section>
      <CTABand />
    </div>
  );
}
